/* ═══════════════════════════════════════════════════════════════════════
   NoteFlow — ai-rewrite.ts
   AI-powered rewrite of note disclosure text to SEC 10-K quality
   Calls the aiRewrite Cloud Function (server-side Anthropic proxy)
   ═══════════════════════════════════════════════════════════════════════ */

import { meta } from './utils';

declare const firebase: any;

// FIELD_CONTEXT moved to the aiRewrite Cloud Function (functions/index.js)
// where it's used to build the system prompt server-side.

/**
 * Rewrites user text in professional SEC 10-K disclosure language
 * via the aiRewrite Cloud Function (server-side Anthropic proxy).
 */
export async function aiRewrite(targetId: string): Promise<void> {
  const textarea = document.getElementById(targetId) as HTMLTextAreaElement | null;
  if (!textarea) return;

  const userText = textarea.value.trim();
  if (!userText) {
    alert('Please enter some text first, then click AI Rewrite to enhance it.');
    return;
  }

  // Find the button and show loading state
  const btn = document.querySelector(`[data-target="${targetId}"]`) as HTMLButtonElement | null;
  if (btn) {
    btn.disabled = true;
    btn.innerHTML = '<span class="ai-spinner"></span> Rewriting...';
  }

  const m = meta();

  try {
    const callable = firebase.functions().httpsCallable('aiRewrite');
    const result = await callable({
      text: userText,
      targetId,
      company: m.company,
      period: m.period,
    });

    const rewrittenText = result.data.rewrittenText;

    if (rewrittenText) {
      // Store original for undo
      textarea.dataset.originalText = userText;
      textarea.value = rewrittenText;
      // Trigger input event so any listeners pick up the change
      textarea.dispatchEvent(new Event('input', { bubbles: true }));

      if (btn) {
        btn.innerHTML = '↩ Undo Rewrite';
        btn.disabled = false;
        btn.onclick = function() {
          textarea.value = textarea.dataset.originalText || userText;
          textarea.dispatchEvent(new Event('input', { bubbles: true }));
          btn.innerHTML = '✨ AI Rewrite';
          btn.onclick = null;
        };
        return; // Don't reset button below
      }
    }
  } catch (err: any) {
    const message = err.message || 'Unknown error';
    alert('AI Rewrite failed: ' + message);
  }

  if (btn) {
    btn.disabled = false;
    btn.innerHTML = '✨ AI Rewrite';
  }
}
